import React from 'react';
import dateFormat from 'dateformat';
const SingleItem = ({ data }) => {
    return (
        <>
            <tr>
                <td >
                    <div className='fw-bolder'>
                        {data?.trx}
                    </div>
                </td>
                <td>{dateFormat(data?.createdAt, "mmmm,")}&nbsp;{dateFormat(data?.createdAt, "dS")}&nbsp;{dateFormat(data?.createdAt, "yyyy")}</td>

                <td>
                    {data?.amount}$
                </td>
                <td>
                {!isNaN(data?.post_balance) && parseFloat(data?.post_balance).toFixed(2)}$
                </td>
                <td>{data?.details}</td>

            </tr>

        </>
    );
};

export default SingleItem;